
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { IconButton } from "office-ui-fabric-react";
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    root: {
        paddingLeft: '0.2em',
    }
});



const ToolbarLink = ({
    items
}) => {

    return (
        <Stack horizontal className={classNames.root}>
            {items.map((item, index) => {

                const handleClick = () => {
                    if (item.onClick) {
                        item.onClick(item);
                    }
                }

                let iconName;
                if (item.title === 'Rozbalit') {
                    iconName = "DoubleChevronDown12"
                } else if (item.title === 'Sbalit') {
                    iconName = "DoubleChevronUp12"
                } else if (item.title === 'Přidat') {
                    iconName = "AddNotes"
                } else if (item.title === 'Smazat') {
                    iconName = "Delete"
                } else if (item.title === 'Upravit') {
                    iconName = "EditSolid12"
                } else {
                    iconName = "CheckboxFill"
                    console.log('ITEM.TITLE >>', item.title)
                }

                //<Link key={index} onClick={handleClick} >{item.title}</Link>
                return (
                    <Stack key={index}>
                        <TooltipHost content={item.title}>
                            <IconButton
                                styles={{
                                    root: {
                                        color: '#000000'
                                    }
                                }}
                                iconProps={{iconName: iconName}}
                                onClick={handleClick}
                                aria-label={item.title}
                                key={index}
                            />
                        </TooltipHost>
                    </Stack>
                );
            })}
        </Stack>
    );
}

export default ToolbarLink;
